/**
 * HeaderBrandSlot 컴포넌트
 * @description 헤더 왼쪽의 브랜드 — 홈으로 가는 링크. 웹에만 있는 슬롯이다.
 *   링크를 타고 처음 온 사람에게 이 화면은 출처 없는 페이지라 이름이 먼저다.
 *   줄 높이는 앱 헤더의 검색창(48)과 같아 슬롯이 바뀌어도 헤더 높이(64)가 그대로다.
 *
 *   심볼과 워드마크를 따로 세우지 않고 3.0 락업 그림 한 장을 쓴다 — 글자로 조판하면 자간과
 *   굵기가 서체가 도착하기 전까지 흔들린다. 바탕이 밝을 때와 어두울 때 워드마크 색이 다른
 *   두 벌이라 둘 다 심고 아닌 쪽은 CSS 가 감춘다(`.fw-theme-*-only`, globals.css) —
 *   서버가 그린 HTML 에 맞는 쪽이 이미 들어 있어야 첫 그림이 한 번 틀렸다가 바뀌지 않는다.
 * @example
 * <Header inset='tab'><HeaderBrandSlot /></Header>
 */
import Image from "next/image";
import Link from "next/link";
import { memo } from "react";

import { HEADER_BRAND_LOCKUP, headerBrandSlotStyles } from "./Header.styles";

import { SITE_NAME } from "@/shared/config";
import { routes } from "@/shared/config/routes";

/** 바탕색으로 고르는 두 벌. `dark` 가 어두운 바탕용(흰 워드마크)이다. */
const LOCKUPS = [
  {
    src: "/assets/images/3.0/fanwork-logo-extend-light.png",
    themeClassName: "fw-theme-light-only",
  },
  {
    src: "/assets/images/3.0/fanwork-logo-extend-dark.png",
    themeClassName: "fw-theme-dark-only",
  },
] as const;

const HeaderBrandSlot = memo(() => (
  <div className={headerBrandSlotStyles.root}>
    <Link
      href={routes.home}
      aria-label={SITE_NAME}
      className={headerBrandSlotStyles.logo}
    >
      {LOCKUPS.map(({ src, themeClassName }) => (
        <Image
          key={themeClassName}
          src={src}
          /* 링크가 이미 이름을 말한다(aria-label) — 그림은 장식이다 */
          alt=""
          width={HEADER_BRAND_LOCKUP.width}
          height={HEADER_BRAND_LOCKUP.height}
          /* 첫 화면의 이름이라 늦게 오면 안 된다. 두 벌 다 받지만 한 벌이 2KB 대다 */
          loading="eager"
          className={`${headerBrandSlotStyles.lockup} ${themeClassName}`}
          style={{ height: HEADER_BRAND_LOCKUP.height }}
        />
      ))}
    </Link>
  </div>
));

HeaderBrandSlot.displayName = "HeaderBrandSlot";

export default HeaderBrandSlot;
